import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import SortableItem from './SortableItem';

const SortableList = SortableContainer(({ items }) => (
  <ul className="sortable-list faux-list">
    {items.map((value, index) => (
      <SortableItem key={value.props.id} index={index} value={value} />
    ))}
  </ul>
));

export default SortableList;



// WEBPACK FOOTER //
// ./library/app/components/Global/Sortable/SortableList.js